import React from 'react';
import { Html } from './view/html';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'Html', 
  itemElt: (item, cmsOption) => <Html item={item} cmsOption={cmsOption} />
}